import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Mail, Phone, Loader2, ArrowLeft } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ICON_URL = "https://customer-assets.emergentagent.com/job_online-pflegekasse/artifacts/72f9n7x9_1775301634776.png";

export default function PortalLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Check if already logged in
  const token = localStorage.getItem("lw_portal_token");
  if (token) { navigate("/portal"); return null; }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!email || !phone) { setError("Bitte füllen Sie beide Felder aus."); return; }
    setLoading(true);
    try {
      const res = await axios.post(`${API}/portal/login`, { email, phone });
      localStorage.setItem("lw_portal_token", res.data.token);
      localStorage.setItem("lw_portal_name", res.data.name);
      navigate("/portal");
    } catch (err) {
      setError(err.response?.data?.detail || "Anmeldung fehlgeschlagen");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4" data-testid="portal-login">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="h-14 w-14 shrink-0 overflow-hidden">
              <img src={ICON_URL} alt="Logo" className="h-full w-auto object-cover object-left scale-[2.3] origin-[15%_41%]" />
            </div>
          </div>
          <h1 className="font-['Manrope'] text-2xl font-bold text-slate-900">Mein Bereich</h1>
          <p className="text-base text-slate-500 mt-2">
            Melden Sie sich mit Ihrer E-Mail und Telefonnummer an, die Sie bei der Buchung verwendet haben.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-lg border border-slate-200/60 p-8">
          <form onSubmit={handleSubmit} className="space-y-5">
            {error && (
              <div className="bg-red-50 text-red-700 text-sm p-4 rounded-xl border border-red-200" data-testid="portal-login-error">
                {error}
              </div>
            )}
            <div>
              <Label className="text-sm font-semibold text-slate-700 mb-1.5 block">E-Mail-Adresse</Label>
              <div className="relative">
                <Mail className="absolute left-3.5 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" />
                <Input
                  data-testid="portal-email"
                  type="email"
                  placeholder="ihre@email.de"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="h-13 pl-11 rounded-xl text-base"
                />
              </div>
            </div>
            <div>
              <Label className="text-sm font-semibold text-slate-700 mb-1.5 block">Telefonnummer</Label>
              <div className="relative">
                <Phone className="absolute left-3.5 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" />
                <Input
                  data-testid="portal-phone"
                  type="tel"
                  placeholder="0176 ..."
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  className="h-13 pl-11 rounded-xl text-base"
                />
              </div>
            </div>
            <Button
              type="submit"
              data-testid="portal-login-btn"
              disabled={loading}
              className="w-full bg-cyan-700 hover:bg-cyan-600 text-white rounded-xl h-13 text-lg font-semibold active:scale-[0.98]"
            >
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Anmelden"}
            </Button>
          </form>
        </div>

        <div className="text-center mt-6 space-y-2">
          <p className="text-sm text-slate-400">
            Nutzen Sie die gleichen Daten wie bei Ihrer Terminbuchung.
          </p>
          <a href="/" className="inline-flex items-center gap-1 text-sm text-cyan-700 hover:underline">
            <ArrowLeft className="h-3.5 w-3.5" /> Zurück zur Website
          </a>
        </div>
      </div>
    </div>
  );
}
